export default __webpack_public_path__ + "static/media/user.785ee99f.svg";